import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-892eec6a")
const _hoisted_1 = { class: "developerGames" }
const _hoisted_2 = { class: "_header" }
const _hoisted_3 = { class: "_headerBack" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "_dev" }, "Dev"),
  /*#__PURE__*/_createTextVNode("Games ")
], -1)
const _hoisted_5 = { class: "_controls" }
const _hoisted_6 = { class: "_main" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Let's start with a title. ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_GamePreview = _resolveComponent("GamePreview")!
  const _component_PopupInput = _resolveComponent("PopupInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_IconButton, {
            icon: "back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace({path:'/app'}))),
            white: true
          })
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_TextInput, {
            placeholder: "Search",
            icon: "search",
            shrunk: true
          }),
          _createVNode(_component_Dropdown, {
            text: "Sort by",
            options: _ctx.sortOptions,
            white: true,
            onUpdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sortOptions.active = $event))
          }, null, 8, ["options"]),
          _createVNode(_component_IconButton, {
            icon: "add",
            type: "svg",
            success: _ctx.gameCreated,
            fail: _ctx.gameFail,
            onClick: _ctx.newGame
          }, null, 8, ["success", "fail", "onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game, index) => {
          return (_openBlock(), _createBlock(_component_GamePreview, {
            game: game,
            popout: [
            {
              text:'Edit',
              function:()=>{_ctx.editGame(game.id)}
            },
            {
              text:'Delete',
              function:()=>{_ctx.del(game,index)}
            },
          ],
            linear: true,
            key: index,
            onClick: ($event: any) => (_ctx.editGame(game.id))
          }, null, 8, ["game", "popout", "onClick"]))
        }), 128))
      ])
    ]),
    (_ctx.popupDisplay)
      ? (_openBlock(), _createBlock(_component_PopupInput, {
          key: 0,
          header: "New game",
          onResolve: _cache[2] || (_cache[2] = ($event: any) => (_ctx.create($event))),
          onReject: _cache[3] || (_cache[3] = ($event: any) => (_ctx.popupDisplay=false)),
          inputs: [{
        name:'title',
        placeholder:'Aa',
        label:'Title'
    }],
          ref: "newGamePopup"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 512))
      : _createCommentVNode("", true)
  ], 64))
}